import { Link } from "react-router-dom";
import { formatDate } from "@/lib/utils/format";

interface TopicSidebarProps {
  topic: {
    id: string; name: string; slug: string; description: string | null;
    color: string; rules: unknown[];
  };
  isSubscribed: boolean;
  userId: string | null;
}

export function TopicSidebar({ topic, isSubscribed, userId }: TopicSidebarProps) {
  const rules = (topic.rules as Array<{ title: string; description?: string }>) || [];

  return (
    <div className="space-y-4">
      {rules.length > 0 && (
        <div className="panel">
          <p className="section-title mb-3">Community rules</p>
          <ol className="space-y-3">
            {rules.map((rule, i) => (
              <li key={i} className="flex gap-2.5">
                <span className="text-xs font-bold text-brand mt-0.5">{i + 1}.</span>
                <div>
                  <p className="text-xs font-medium text-foreground">{rule.title}</p>
                  {rule.description && <p className="text-xs text-text-subtle mt-0.5">{rule.description}</p>}
                </div>
              </li>
            ))}
          </ol>
        </div>
      )}

      <div className="panel">
        <p className="section-title mb-3">Posting guidelines</p>
        <ul className="space-y-2 text-xs text-text-muted">
          {["Be respectful and constructive", "Stay on topic", "No spam or self-promotion", "Use descriptive titles", "Search before posting"].map(g => (
            <li key={g} className="flex items-center gap-2">
              <svg className="w-3.5 h-3.5 text-success flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {g}
            </li>
          ))}
        </ul>
      </div>

      {userId && (
        <Link to={`/post/create?topic=${topic.slug}`} className="btn-primary btn-md w-full">
          Create a post
        </Link>
      )}
    </div>
  );
}
